import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {  Col, Row } from "react-bootstrap";
import classes from "./UIStyles.module.scss"

const ErrorAlert =({text, ...props})=>{
    return(
        <Row className={classes["errorAlert"]} {...props}>
            <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
            <Col>{text}</Col>
        </Row>
        )
}

export default ErrorAlert;